import React from 'react'
import { useBlogs, generateSlug } from '../../services/blogService';
import BlogListMain from '../../inner/BlogListMain';

function BlogNine() {
    const { data: blogs = [], isLoading } = useBlogs();
    
    // Get the 2 most recent blogs
    const recentBlogs = blogs.slice(0, 2);

    return (
        <div>
            {/* blog post area start */}
            <div className="blog-post-ten-area rts-section-gapTop pb--60" id='blog-section'>
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="title-area-left-ten center">
                                <span className="pre-title">Blog Updates</span>
                                <h2 className="title">
                                    Most Recent <span>Blog Posts</span>
                                </h2>
                            </div>
                        </div>
                    </div>
                    {isLoading ? (
                        <div className="row g-5 mt--30">
                            {[1, 2].map((item) => (
                                <div key={item} className="col-lg-6">
                                    <div className="single-blog-style-ten" style={{ opacity: 0.6 }}>
                                        <div className="thumbnail" style={{ 
                                            background: '#f0f0f0', 
                                            height: '250px', 
                                            borderRadius: '8px',
                                            animation: 'pulse 1.5s ease-in-out infinite'
                                        }} />
                                        <div className="information" style={{ paddingTop: '20px' }}>
                                            <div className="blog-top-area">
                                                <div className="single-area" style={{ 
                                                    background: '#f0f0f0', 
                                                    width: '120px', 
                                                    height: '20px',
                                                    borderRadius: '4px',
                                                    animation: 'pulse 1.5s ease-in-out infinite'
                                                }} />
                                            </div>
                                            <div className="main-wrapper" style={{ marginTop: '15px' }}>
                                                <div style={{ 
                                                    background: '#f0f0f0', 
                                                    width: '100%', 
                                                    height: '24px',
                                                    borderRadius: '4px',
                                                    marginBottom: '10px',
                                                    animation: 'pulse 1.5s ease-in-out infinite'
                                                }} />
                                                <div style={{ 
                                                    background: '#f0f0f0', 
                                                    width: '80%', 
                                                    height: '24px',
                                                    borderRadius: '4px',
                                                    animation: 'pulse 1.5s ease-in-out infinite'
                                                }} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))}
                            <style>{`
                                @keyframes pulse {
                                    0%, 100% { opacity: 1; }
                                    50% { opacity: 0.5; }
                                }
                            `}</style>
                        </div>
                    ) : recentBlogs.length > 0 ? (
                        <div className="row g-5 mt--30">
                            {recentBlogs.map((blog, index) => (
                                <div 
                                    key={blog.id || index} 
                                    className="col-lg-6"
                                >
                                    <div className="blog-grid-inner">
                                        <BlogListMain
                                            blogID={generateSlug(blog.title)}
                                            blogImage={blog.image}
                                            blogTitle={blog.title}
                                            blogCategory={blog.category}
                                            blogPublishedDate={blog.publishedDate}
                                        />
                                    </div>
                                </div>
                            ))}
                        </div>
                    ) : (
                        <div className="row g-5 mt--30">
                            <div className="col-lg-12 text-center py-5">
                                <div style={{
                                    padding: '60px 20px',
                                    background: '#f8f9fa',
                                    borderRadius: '12px',
                                    border: '2px dashed #dee2e6'
                                }}>
                                    <i className="far fa-file-alt" style={{ 
                                        fontSize: '48px', 
                                        color: '#adb5bd',
                                        marginBottom: '20px',
                                        display: 'block'
                                    }} />
                                    <p style={{ 
                                        fontSize: '18px', 
                                        color: '#6c757d',
                                        margin: 0,
                                        fontWeight: '500'
                                    }}>
                                        No blogs available at the moment.
                                    </p>
                                    <p style={{ 
                                        fontSize: '14px', 
                                        color: '#adb5bd',
                                        marginTop: '10px'
                                    }}>
                                        Check back soon for updates!
                                    </p>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </div>
            {/* blog post area end */}
        </div>
    )
}

export default BlogNine